<template>
  <div class="list-wrapper">
    <div class="content-wrapper">
      <div class="h-full">
        <div class="c_group">
          <query-form
            class="content_block"
            label-width="100px"
            size="small"
            label-position="right"
            @search="getList('init')"
            @reset="handleReset"
            :keepOpenedRow="2">
            <el-form-item label="发货状态" :span="24">
              <check-tag
                v-model="advancedForm.status"
                @change="() => getList('init')"
              >
                <check-tag-item
                  :value="i.value"
                  :key="i.value"
                  v-for="i in executionStatusGroup"
                  :label="`${i.label}(${i.count || 0})`"
                ></check-tag-item>
              </check-tag>
            </el-form-item>
            <el-form-item label="销售订单号">
              <el-input
                v-model.trim="advancedForm.orderCode"
                clearable
                placeholder="请输入销售订单号"
              ></el-input>
            </el-form-item>
            <el-form-item label="销售合同号">
              <el-input
                v-model.trim="advancedForm.contractCode"
                clearable
                placeholder="请输入销售合同号"
              ></el-input>
            </el-form-item>
            <el-form-item label="物流填单">
              <el-select v-model.trim="advancedForm.logisticsFillType" clearable placeholder="请选择" @change="getList('init')">
                <el-option label="全部" value=""></el-option>
                <!-- <el-option label="未确认" :value="1"></el-option> -->
                <el-option label="线下填单" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收货人">
              <el-input
                v-model.trim="advancedForm.receiverName"
                clearable
                placeholder="请输入收货人"
              ></el-input>
            </el-form-item>
          </query-form>
        </div>
        <div class="table-wrapper" :class="{ 'fullscreen': isFullScreen }">
          <xz-table
            ref="xzTable"
            :columns="columnList"
            :data="dataList"
            :toolsAttrs="toolsAttrs"
            :scroll="{ x: '100%', y: scrollHeight }"
            rowKey="id"
            :isNest="true"
            :expandedRowKeys.sync="expandedRowKeys"
            @openCloseAll="openCloseAll"
            @refresh="handleReset"
            @fullScreen="handleFullScreen"
            @expand="expandedOneRow">
            <template v-if="showUpdateDelivery && $withPermission('gongxutong:lvyue:deliver_goods:sync')" #buttons>
              <el-button type="primary" size="mini" @click="handleUpdate">发货单更新</el-button>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>发货单更新前，请确保订单更新完成，否则发货单可能更新不成功。</span>
                </template>
                <a-icon type="exclamation-circle" style="font-size: 14px;" />
              </a-tooltip>
            </template>
            <template #custom>
              <tableHeaderConfiguration businessType="invoiceMgr" :disabledList="disabledList" :baseLists="baseLists" @updateColumnList="updateColumnList" />
            </template>
            <div slot="action" slot-scope="_, row">
              <a v-if="$withPermission('gongxutong:lvyue:deliver_goods:detail')" @click="() => handleDetail(row)">查看</a>
              <a v-if="row.dockingSystem === 'XIAOZI_ERP' && $withPermission('gongxutong:lvyue:deliver_goods:cancel') && row.status === 1" style="margin-left: 8px" @click="() => handleCancelErp(row)">取消</a>
              <a v-if="row.dockingSystem !== 'XIAOZI_ERP' && $withPermission('gongxutong:lvyue:deliver_goods:cancel') && row.status === 1 && [1, 2].includes(row.orderReceiveStatus)" style="margin-left: 8px" @click="() => handleCancel(row)">取消</a>
            </div>
            <xz-table
              rowKey="id"
              class="subTable"
              slot="expandedRowRender"
              slot-scope="row"
              :columns="subColumnsLists"
              :data="row.deliveryGoodsList">
              <template slot="imageList" slot-scope="image">
                <span v-if="image && image.split(',').length > 0">
                  <span v-for="(img, i) in image.split(',')" :key="'img-'+i">
                    <el-image v-if="i < 2" style="width: 32px; height: 32px; margin-right: 5px;" :src="img" :preview-src-list="image.split(',')" />
                  </span>
                  <span v-if="image.split(',').length > 2" style="color:#3182bd; margin-left: 2px;">...</span>
                </span>
                <span v-else>暂无图片</span>
              </template>
            </xz-table>
          </xz-table>
        </div>
      </div>
    </div>
    <div class="pagination-wrapper">
      <a-pagination
        :current="pagination.pageNum"
        :total="total"
        :show-total="total => `共 ${total || 0} 条`"
        show-size-changer
        :pageSizeOptions="['10', '20', '30', '50', '100']"
        show-quick-jumper
        :pageSize.sync="pagination.pageSize"
        @change="handleNumChange"
        @showSizeChange="handleSizeChange"
      />
    </div>
  </div>
</template>
<script>
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import { queryPage, queryStateInfo, cancel, pullXzErpDelivery, cancelDelivery } from '@/api/invoiceMgr';
import { tenantDetail } from '@/api/shop';
import { SUB_COMMON_COLUMS } from './configs/detailConfig';
import tableHeaderConfiguration from '@/components/tableHeaderConfiguration.vue';

import * as Moment from 'dayjs';

const executionStatusGroup = [
  {
    label: '全部',
    value: '',
    en: 'allCount',
    count: 0,
  },
  {
    label: '已发货',
    value: '1',
    en: 'deliveryCount',
    count: 0,
  },
  {
    label: '已取消',
    value: '2',
    en: 'cancelCount',
    count: 0,
  },
];

const COMMON_COLUMNS = [
  {
    title: '发货单号',
    dataIndex: 'code',
    key: 'code',
    width: 160,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '发货状态',
    dataIndex: 'status',
    key: 'status',
    width: 100,
    ellipsis: true,
    customRender: text => {
      let status = '--';
      for (let v of executionStatusGroup) {
        if (v.value * 1 === text) {
          status = v.label;
        }
      }
      return status;
    },
  },
  {
    title: '物流填单',
    dataIndex: 'logisticsFillTypeDesc',
    key: 'logisticsFillTypeDesc',
    width: 100,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '物流信息',
    dataIndex: 'logisticsList',
    key: 'logisticsList',
    width: 220,
    ellipsis: true,
    customRender: text => {
      return text?.length ? `${text[0].logisticsCompanyName}_${text[0].code}` : '--';
    },
  },
  // {
  //   title: '物流单号',
  //   dataIndex: 'oddNumbers',
  //   key: 'oddNumbers',
  //   width: 200,
  //   ellipsis: true,
  //   customRender: text => {
  //     return text || '--';
  //   },
  // },
  {
    title: '发货商品',
    dataIndex: 'deliveryGoodsList',
    key: 'deliveryGoodsList',
    width: 220,
    ellipsis: true,
    customRender: text => {
      return text?.length ? text.map(item => `${item.goodsName}*${item.model}*${item.quantity}`).join(';') : '--';
    },
  },
  {
    title: '客户名称',
    dataIndex: 'customerName',
    key: 'customerName',
    width: 200,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '销售订单号',
    dataIndex: 'orderCode',
    key: 'orderCode',
    width: 160,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '销售合同号',
    dataIndex: 'outContractCode',
    key: 'outContractCode',
    width: 160,
    customRender: (text, row) => {
      return row.dockingSystem === 'XIAOZI_ERP' ? text || '--' : row.contractCode || '--';
    },
  },
  {
    title: '收货人',
    dataIndex: 'receiverName',
    key: 'receiverName',
    width: 120,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '更新时间',
    dataIndex: 'lastUpdateTime',
    key: 'lastUpdateTime',
    width: 180,
    ellipsis: true,
    customRender: (text) => {
      return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
    },
  },
];

export default {
  name: 'InvoiceMgr',
  components: {
    xzTable,
    tableHeaderConfiguration,
  },
  computed: {
    toolsAttrs () {
      return {
        refresh: true,
        zoom: true,
        fullScreen: this.isFullScreen,
        // advancedSearch: true,
        custom: true,
      };
    },
  },
  data () {
    return {
      expandedRowKeys: [],
      showUpdateDelivery: false,
      disabledList: ['code', 'status', 'logisticsList'],
      dataList: [],
      advancedForm: {
        status: '',
        logisticsFillType: '',
      },
      executionStatusGroup,
      columnList: [
        ...COMMON_COLUMNS,
      ],
      baseLists: [
        ...COMMON_COLUMNS,
      ],
      subColumnsLists: [
        ...SUB_COMMON_COLUMS,
      ],
      scrollHeight: 'calc(100vh - 220px - 70px - 110px)',
      isFullScreen: false,
      total: 0,
      pagination: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  async created () {
    const userInfo = this.$local.get('userInfo') ? JSON.parse(this.$local.get('userInfo')) : {};
    const { body } = await tenantDetail({
      id: userInfo.tenantId,
      findActivateServiceFlag: true,
    });
    if (body.activateService && body.activateService.includes('小紫VIS')) {
      this.showUpdateDelivery = true;
    }
    this.getList();
    this.getCount();
  },
  methods: {
    updateColumnList (columnList) {
      this.columnList = [
        ...columnList,
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          fixed: 'right',
          width: 140,
          scopedSlots: { customRender: 'action' },
        },
      ];
      setTimeout(() => {
        this.expandedRowKeys = [];
        this.$refs.xzTable.addElementsToClass();
      }, 0);
    },
    handleFullScreen () {
      this.isFullScreen = !this.isFullScreen;
    },
    handleSizeChange (_, size) {
      this.pagination.pageSize = size;
      this.getList();
    },
    handleNumChange (num) {
      this.pagination.pageNum = num;
      this.getList();
    },
    openCloseAll () {
      setTimeout(() => {
        this.expandedRowKeys.forEach((key) => {
          const elements = document.querySelectorAll(`[data-row-key='${key}-extra-row']`);
          const length = elements.length;
          const height = elements[0].offsetHeight - 18.6;
          const tableContents = elements[0].querySelectorAll('.ant-table-content');
          if (tableContents.length) {
            for (let i = 0; i < tableContents.length; i++) {
              tableContents[i].style.paddingRight = 200 + 'px';
            }
          }

          elements[length - 1].childNodes[0].innerHTML = `<div style='height: ${height}px;'></div>`;

          // 设置fixed-left时，子表格paddingRight为0
          const fixedTableLeft = document.querySelectorAll('.ant-table-fixed-left');
          if (fixedTableLeft.length) {
            const fixedRows = fixedTableLeft[0].querySelectorAll(`[data-row-key='${key}-extra-row']`);
            if (fixedRows.length) {
              const fixedRowsSecondTd = fixedRows[0].querySelectorAll('td')[1];
              if (fixedRowsSecondTd) {
                fixedRowsSecondTd.style.paddingRight = 0;
              }
            }
          }
        });
      }, 0);
    },
    expandedOneRow (_, rec) {
      setTimeout(() => {
        const elements = document.querySelectorAll(`[data-row-key='${rec.id}-extra-row']`);
        const length = elements.length;
        const height = elements[0].offsetHeight - 18.6;
        const tableContents = elements[0].querySelectorAll('.ant-table-content');

        if (tableContents.length) {
          for (let i = 0; i < tableContents.length; i++) {
            tableContents[i].style.paddingRight = 200 + 'px';
          }
        }

        elements[length - 1].childNodes[0].innerHTML = `<div style='height: ${height}px;'></div>`;

        // 设置fixed-left时，子表格paddingRight为0
        const fixedTableLeft = document.querySelectorAll('.ant-table-fixed-left');
        if (fixedTableLeft.length) {
          const fixedRows = fixedTableLeft[0].querySelectorAll(`[data-row-key='${rec.id}-extra-row']`);
          if (fixedRows.length) {
            const fixedRowsSecondTd = fixedRows[0].querySelectorAll('td')[1];
            if (fixedRowsSecondTd) {
              fixedRowsSecondTd.style.paddingRight = 0;
            }
          }
        }
      }, 0);
    },
    async handleUpdate () {
      const { body } = await pullXzErpDelivery({});
      this.$message.success(`更新成功，共更新 ${body} 条数据`);
      this.handleReset();
    },
    getList (type) {
      if (type === 'init') {
        this.total = 0;
        this.pagination = {
          pageNum: 1,
          pageSize: 10,
        };
      }

      let { pageSize, pageNum } = this.pagination;
      let orderBy = [
        {
          orderByProperty: 'lastUpdateTime',
          orderByType: 'DESC',
        },
      ];

      queryPage({
        ...this.advancedForm,
        findDeliveryGoodsFlag: true,
        findLogisticsFlag: true,
        findOrderFlag: true,
        orderBy,
        pageSize,
        pageNum,
      }).then(({ body }) => {
        const data = (body.list || []).map(v => {
          v.deliveryGoodsList.map(item => {
            item.dockingSystem = v.dockingSystem;
          });
          return v;
        });
        this.dataList = data;
        this.total = +body.total || 0;

        setTimeout(() => {
          this.expandedRowKeys = [];
          this.$refs.xzTable.addElementsToClass();
        }, 0);
      });
    },
    getCount () {
      queryStateInfo().then(({ body }) => {
        for (let v of this.executionStatusGroup) {
          v.count = body[v.en];
        }
        const allCount = body.deliveryCount + body.cancelCount;
        this.executionStatusGroup[0].count = allCount;
      });
    },
    handleReset () {
      for (let key in this.advancedForm) {
        this.advancedForm[key] = '';
      }

      this.total = 0;
      this.pagination = {
        pageNum: 1,
        pageSize: 10,
      };

      this.getList();
    },
    handleDetail (row) {
      this.$router.push({
        path: '/logistics/invoiceMgr/detail',
        query: {
          id: row.id,
          outDeliveryId: row.outDeliveryId,
          arrivalCode: row.code,
          orderId: row.orderId,
          orderCode: row.orderCode,
          arrivalSts: row.status,
          unit: row.customerName,
          outOrderId: row.outOrderId,
          dockingSystem: row.dockingSystem,
        },
      });
    },
    handleCancelErp (row) {
      this.$confirm(`确认取消发货[${row.code}]吗？`, '取消', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        cancel({id: row.outDeliveryId}).then(() => {
          this.$message({
            type: 'success',
            message: '取消成功!',
          });
          this.getList('init');
        });
      });
    },
    handleCancel (row) {
      this.$confirm(`确认取消发货[${row.code}]吗？`, '取消', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        cancelDelivery({id: row.id}).then(() => {
          this.$message({
            type: 'success',
            message: '取消成功!',
          });
          this.getList('init');
        });
      });
    },
  },
};
</script>
<style lang='scss' scoped>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
}
.list-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  .content-wrapper {
    flex: 1;
    overflow: hidden;
    padding: 0 0 8px;

    .h-full {
      height: 100%;
      background-color: #fff;
      display: flex;
      flex-direction: column;

      .c_group {
        position: relative;

        .content_block {
          border-bottom: 0.5px solid #DFE2E8;
          padding: 10px;
        }

        .title {
          font-size: 14px;
          font-weight: 600;
          padding-right: 2em;
        }
      }

      .table-wrapper {
        padding: 16px 12px;
        flex: 1;
        overflow: auto;

        .ant-radio-button-wrapper {
          border-width: 0;
          background-color: #f2f4f7;

          &.active-radio {
            border-color: #e2f3fe;
            background-color: #e2f3fe;
            color: #237ffa;
          }
        }

        .ant-radio-button-wrapper:not(:first-child)::before {
          width: 0;
        }
      }
    }
  }

  .table-wrapper.fullscreen {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0px;
    z-index: 100;
    background: #FFFFFF;
  }
}

/deep/.ant-table-body::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}

/deep/ .ant-table-body::-webkit-scrollbar-thumb {
  border-radius: 8px;
  box-shadow: inset 0 0 5px #c9ced6;
  background: #c9ced6;
}

//鼠标移入样式
/deep/ .ant-table-body::-webkit-scrollbar-thumb:hover {
  background: #c9ced6;
}

/deep/.ant-drawer-body {
  padding: 16px;
}
</style>
